import React, { Component } from 'react';
import { Card, CardBody, Table, Col, Row } from 'reactstrap'
import { Pagination } from 'semantic-ui-react';
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import { Services } from '../../Reports/Services';
import { saveAs } from 'file-saver';


export default class TableComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activePage: 0,
      search: '',
      data: this.props.data,
      downloadingxlsx: false,
      info: this.props.info,
      loader: false,
      disable: false,
      totalPages: 0,
      itemsByPage: this.props.itemsByPage ? this.props.itemsByPage : 10
    }

  }

  componentDidMount = () => {
    this.setState({ data: this.props.data, dataPage: this.props.data, allData: this.props.data }, () => { this.initPages() })
  }
  componentWillReceiveProps = (nextProps) => {
    this.setState({ data: nextProps.data, dataPage: nextProps.data, allData: nextProps.data, info: nextProps.info }, () => { this.initPages() })
  }
  // componentDidUpdate = (prevProps) =>{
  //   console.log("prevProps",prevProps);


  // }

  initPages = () => {
    const { dataPage, itemsByPage } = this.state
    let pag = Math.ceil(parseInt(dataPage.length) / itemsByPage)
    this.setState({
      activePage: 1,
      totalPages: pag,
    })
  }

  getKeys = () => {
    return Object.keys(this.props.data[0]);
  }

  getHeader = () => {
    var keys = this.getKeys();
    return keys.map((key, index) => {
      return <th className='reports-table-header' key={index}>{key}</th>
    })
  }

  getRowsData = () => {
    const { activePage, data } = this.state

    var items = this.setResultsByPage(activePage, data)
    var keys = this.getKeys();

    return items.map((row, index) => {
      return <tr key={index}><RenderRow key={index} data={row} keys={keys} /></tr>
    })
  }

  handlePaginationChange = (e, { activePage }) => {
    // let { data } = this.state
    // let tableData = this.setResultsByPage(activePage, data)
    this.setState({ activePage })
  }

  setResultsByPage = (page, all) => {
    const { itemsByPage } = this.state
    page = page - 1
    const pag = all.slice((page) * itemsByPage, (page + 1) * itemsByPage)
    return pag
  }

  handleSearch = name => event => this.setState({ [name]: event.target.value }, () => this.setSearch());

  setSearch = () => {
    let all = this.props.data
    let results = []
    all.forEach((e) => {
      let found = 0
      let keys = Object.keys(e)
      keys.forEach((key) => {
        if ((e[key] ? (e[key] + '').toLowerCase().indexOf(this.state.search.toLowerCase()) : -1) >= 0) found += 1
      })
      if (found !== 0) results.push(e)
    })

    this.setState({ data: results, dataPage: results }, () => {
      this.getRowsData()
      this.initPages()
    })
  }

  XLSX = () => {
    const { info } = this.state;
    this.setState({ downloadingxlsx: true, loader: true, disable: true });
    fetch(`${Services.DOWNLOAD_FILES.path}`, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        data: this.state.data,
        info: {
          name: info.name,
          date: info.date,
          results: info.results,
          description: info.description,
          config: {
            // title: info.name,
            headers: {
              name: 'Report Name',
              date: 'Creation Date',
              results: 'Results',
              description: 'Description'
            }
          }
        },
        options: {
          image: {
            name: 'rrmagicvision',
          },
        }
      })
    }).then(data => {
      return data.json();
    }).then(success => {
      if (success.base64) {
        const linkSource = `data:application/xlsx;base64,${success.base64}`;
        // const fileName = (Math.floor(Math.random() * 900000) + 100000) + Math.floor(Date.now() / 1000) + '.xlsx';
        const fileName = `${info.name + info.date}.xlsx`;
        saveAs(linkSource, fileName);
        this.setState({ downloadingxlsx: false, loader: false, disable: false });
      } else console.warn('Error', success);
    })
      .catch(error => {
        console.warn(error);
      });
  }

  render() {

    const { activePage, loader } = this.state
    return (
      <Card>
        <CardBody>
          <Row>
            <Col lg={12} md={12} xs={12}>
              {/* INPUT SEARCH AND ICON TO DOWNLOAD  */}
              <Row>
                <Col xs={3}>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">Search</InputGroupAddon>
                    <Input onChange={this.handleSearch('search')} />
                  </InputGroup>
                </Col>
                <Col xs={9} className='d-flex align-items-center'>
                  <i className={loader ? `fas fa-sync fa-spin fa-2x custom-icon-xls` : `fas fa-file-excel fa-2x custom-icon-xls`} disabled={loader} onClick={this.XLSX} />
                </Col>
              </Row>
            </Col>
            <div className="col-12" style={{ paddingTop: '1%' }}></div>
            <div className="col-12">
              <Table striped responsive>
                <thead className="reportsTitleTable">
                  <tr>
                    {this.getHeader()}
                  </tr>
                </thead>
                <tbody className="report table body">
                  {this.getRowsData()}
                </tbody>
              </Table>
            </div>
            <div className="col-12">
              <hr />
            </div>
            <div className="col-12">
              <hr />
            </div>
            <div className="col-12">
              <center>
                <Pagination
                  ellipsisItem={null}
                  activePage={activePage}
                  totalPages={this.state.totalPages}
                  onPageChange={this.handlePaginationChange}
                >
                </Pagination>
              </center>
            </div>

            <div className="col-12">
              <hr />
            </div>
          </Row>
        </CardBody>
      </Card>

    );
  }
}

const RenderRow = (props) => {
  return props.keys.map((key, index) => {
    return <td className='table-body' key={index}>{props.data[key]}</td>
  })
}
